'use strict';

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _constants = require('./constants');

var _constants2 = _interopRequireDefault(_constants);

var _signatureModal = require('./signature-modal');

var _signatureModal2 = _interopRequireDefault(_signatureModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

require('./edit-signature-modal.scss');

var EditSignatureModal = _react2['default'].createClass({
    displayName: 'EditSignatureModal',


    propTypes: {
        'app': _react2['default'].PropTypes.object.isRequired, // Application
        'type': _react2['default'].PropTypes.string, // Signature or initials (see SignatureModal.TYPE_*)
        'isMobile': _react2['default'].PropTypes.bool, // Whether it should have mobile behavior
        'initialTab': _react2['default'].PropTypes.string, // The tab shown at first (see SignatureModal.TAB_*)
        'onComplete': _react2['default'].PropTypes.func.isRequired, // Callback to interact with the opener function(signature, insertEverywhere, shouldClose)
        'locales': _react2['default'].PropTypes.array.isRequired, // Selected locale (list of one)
        'buttonText': _react2['default'].PropTypes.string, // Text to be displayed on the CTA
        'emailGuid': _react2['default'].PropTypes.string // Email guid for signature upload
    },

    //  ----  LIFECYCLE  ----------------------------------

    getDefaultProps: function getDefaultProps() {

        // NOTE: It does not make sense for canInsertEverywhere to be true here
        // since this component is meant to be used outside the signer page.

        return {
            'type': _constants2['default'].TYPE_SIGNATURE,
            'isMobile': false,
            'initialTab': _constants2['default'].TAB_SAVED,
            'settings': {},
            'canInsertEverywhere': false,
            'locales': ['en-US']
        };
    },

    //  ----  RENDERING  ----------------------------------

    render: function render() {

        // Render the signature modal
        return _jsx('div', {
            className: 'm-edit-signature-modal'
        }, void 0, _react2['default'].createElement(_signatureModal2['default'], this.props));
    }

});

module.exports = EditSignatureModal;


/*****************
 ** WEBPACK FOOTER
 ** ./src/signer/components/common/signature-modal/edit-signature-modal.jsx
 ** module id = 667
 ** module chunks = 0
 **/